import React from "react";
import { Box, Card, Typography, Divider, useMediaQuery,Button } from "@mui/material";
import { Container } from "react-bootstrap";
import theme from "../../utils/theme";
import { useState, useEffect, useRef } from "react";

export default function ResidentialDescription({
  area,
  per_sq,
  price,
  totalPrice,
  description,
}) {

 

  const isMobile = useMediaQuery("(max-width:600px)");
  const formatPrice = (num) => {
    if (!num) return "N/A";
    num = Number(num);

    if (num >= 10000000) return (num / 10000000).toFixed(2) + " Cr";
    if (num >= 100000) return (num / 100000).toFixed(2) + " Lakhs";
    if (num >= 1000) return (num / 1000).toFixed(2) + " K";

    return num.toString();
  };

  const [expanded, setExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    if (textRef.current) {
      setIsOverflowing(
        textRef.current.scrollHeight > textRef.current.clientHeight
      );
    }
  }, [description]);

  return (
    <div>
      <Box
        sx={{
          mt: 4,
          background: "#608900",
          color: "#fff",
          px: 2,
          py: 1,
          width: "fit-content",
          borderRadius: "8px 8px 0 0",
          fontWeight: 500,
        }}
      >
        Description
      </Box>

      <Box
        sx={{
          mt: 0,
          p: isMobile ? 2 : 3,
          background: "#fff",
          borderRadius: 3,
          boxShadow: 2,
        }}
      >
        {/* <Divider /> */}
        {/* <Typography sx={{ mt: 2, whiteSpace: "pre-line"}}>
          Plot Area : {area || ""} Sq.ft
        </Typography>
        <Typography sx={{ mt: 2, whiteSpace: "pre-line"}}>
          Price per Sq.ft:  ₹{price || ""} (₹{formatPrice(price)})
        </Typography>
        <Typography sx={{ mt: 2, whiteSpace: "pre-line"}}>
          Total Price: ₹{totalPrice || ""} (₹{formatPrice(totalPrice)})
        </Typography> */}

        {/* <Typography sx={{ mt: 2, whiteSpace: "pre-line" }}>
          <strong style={{ color: "#608900", fontWeight: 400 }}>
            Description:
          </strong>
          {"\n"}

          {description || ""}

        </Typography> */}
        <Typography
          ref={textRef}
          sx={{
            mt: 2,
            whiteSpace: "pre-line",
            display: "-webkit-box",
            WebkitLineClamp: expanded ? "none" : 4,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
        >
          {"\n"}
          {description || ""}
        </Typography>

        {isOverflowing && (
          <Button
            size="small"
            onClick={() => setExpanded(!expanded)}
            sx={{ mt: 1, textTransform: "none" }}
          >
            {expanded ? "Show less" : "Show more"}
          </Button>
        )}
      </Box>
    </div>
  );
}
